import { getOrderStatus, statusMap } from '../model'
import './OrderCard.css'

export default function OrderCard({ order, onClick, showMaster = false, showMechanic = true, showSendingReminder = false, showSalon = false }) {
    const status = getOrderStatus(order)
    const needsSending = showSendingReminder && status === 'closed' && !order.is_sent

    const borderColor = status === 'open' ? '#FF7438'
        : status === 'in_progress' ? '#F59E0B'
            : status === 'closed' || status === 'sent' ? '#10B981'
                : '#9CA3AF'

    const badgeBg = status === 'open' ? 'rgba(255,116,56,.1)'
        : status === 'in_progress' ? 'rgba(245,158,11,.1)'
            : status === 'closed' || status === 'sent' ? 'rgba(16,185,129,.1)'
                : '#F3F4F6'

    const badgeColor = status === 'open' ? '#FF7438'
        : status === 'in_progress' ? '#F59E0B'
            : status === 'closed' || status === 'sent' ? '#10B981'
                : '#9CA3AF'

    const now = Date.now()
    const waitMin = order.in_progress_at
        ? Math.round((new Date(order.in_progress_at) - new Date(order.created_at)) / 60000)
        : Math.round((now - new Date(order.created_at)) / 60000)
    const waitLive = !order.in_progress_at
    const diagMin = order.approved_at && order.in_progress_at
        ? Math.round((new Date(order.approved_at) - new Date(order.in_progress_at)) / 60000)
        : order.in_progress_at
            ? Math.round((now - new Date(order.in_progress_at)) / 60000)
            : null
    const diagLive = order.in_progress_at && !order.approved_at
    const isExpired = status === 'expired_open' || status === 'expired_progress'

    const waitColor = isExpired ? '#DC2626'
        : waitLive ? '#FF7438'
            : waitMin <= 30 ? '#059669'
                : waitMin <= 60 ? '#F59E0B'
                    : '#DC2626'

    const diagColor = isExpired ? '#DC2626'
        : diagLive ? '#F59E0B'
            : diagMin !== null && diagMin <= 60 ? '#0052FF'
                : diagMin !== null ? '#DC2626'
                    : '#9CA3AF'

    const vibeScore = order.is_sent ? (order.client_interest_score ?? 0) : null
    const vibeColor = vibeScore === null ? '#9CA3AF'
        : vibeScore >= 70 ? 'rgb(16, 185, 129)'
            : vibeScore >= 30 ? 'rgb(255, 116, 56)'
                : 'rgb(220, 38, 38)'
    const vibeBg = vibeScore === null || vibeScore === 0 ? '#F3F4F6'
        : vibeScore >= 70 ? 'rgba(16,185,129,.1)'
            : vibeScore >= 30 ? 'rgba(255,116,56,.1)'
                : 'rgba(220,38,38,.08)'

    const date = new Date(order.period_at || order.completed_at || order.approved_at || order.created_at).toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' })

    return (
        <div className="order-card" onClick={() => onClick(order)} style={{ '--order-accent': borderColor }}>
            <div className="order-card-head">
                <div className="order-card-title">
                    <p className="order-card-car">{order.car_brand} {order.car_model}</p>
                    {vibeScore !== null && (
                        <span className="order-card-vibe" style={{ color: vibeColor, background: vibeBg }}>
                            <i className="ti ti-flame" aria-hidden="true" />{vibeScore}
                        </span>
                    )}
                </div>
                <div className="order-status-stack">
                    <span className="order-card-badge" style={{ background: badgeBg, color: badgeColor }}>
                        {statusMap[status]?.label}
                    </span>
                </div>
            </div>

            <p className="order-card-sub">
                {order.plate && <span className="order-card-plate">{order.plate}</span>}
                <span className="order-card-client">{order.client_name}</span>
            </p>

            <div className="order-card-meta">
                {showSalon && <span className="order-card-salon">Салон: {order.salon_name || '—'}</span>}
                <span><i className="ti ti-calendar" aria-hidden="true" />{date}</span>
                {showMechanic && order.mechanic_name && <span><i className="ti ti-tool" aria-hidden="true" />{order.mechanic_name}</span>}
                {showMaster && order.master_name && <span><i className="ti ti-user" aria-hidden="true" />{order.master_name}</span>}
            </div>

            <div className="order-card-times">
                <span className="order-card-chip">
                    <i className="ti ti-clock" aria-hidden="true" />Ожидание:
                    <b style={{ color: waitColor }}>{waitMin} мин{waitLive ? ' ↑' : ''}</b>
                </span>
                {diagMin !== null && (
                    <span className="order-card-chip">
                        <i className="ti ti-tool" aria-hidden="true" />Диагностика:
                        <b style={{ color: diagColor }}>{diagMin} мин{diagLive ? ' ↑' : ''}</b>
                    </span>
                )}
            </div>

            {needsSending && (
                <div className="order-card-need" style={{ color: '#DC2626', background: '#FEF2F2' }}>
                    <i className="ti ti-send" aria-hidden="true" />
                    Нужно отправить
                </div>
            )}
        </div>
    )
}
